

















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ListAppItem } from './models/ListApp';

@Component({})
export default class ContentHighlightsListItemEdit extends Vue {
	@Prop() public value: ListAppItem;

	@Prop() public itemIndex: number;

	@Prop() public totalItems: number;

	@Prop() public v: any;

	public markAsTouched(key: keyof ListAppItem) {
		const field = this.v[key];
		if (field) {
			field.$touch();
		}
		this.$emit('input');
	}

	public getErrorMessage(
		fieldName: keyof ListAppItem,
		label: string
	): string | null {
		const field = this.v[fieldName];
		if (field && field.$dirty && field.$invalid) {
			if (field.$params.required && !field.required) {
				return `${label} is required`;
			}
			if (field.$params.url && !field.url) {
				return `${label} must be a valid URL`;
			}
		}
		return null;
	}

	public removeItem() {
		this.$emit('remove');
	}
}
